import {
  CompanyShareClassOwnershipShallowComposite,
  CompanyShareOwnershipBeneficialCompositeEntity,
  CompanyShareOwnershipDirectCompositeEntity,
  CompanyShareOwnershipIndirectCompositeEntity,
  CompanyShareOwnershipUltimateCompositeEntity,
} from '../extensions/app-extensions';

export function isCompanyShareClassOwnershipShallowComposite(
  item: unknown,
): item is CompanyShareClassOwnershipShallowComposite {
  return (
    typeof item === 'object' &&
    item !== null &&
    item.hasOwnProperty('company_share_class_ownership') &&
    item.hasOwnProperty('share_class')
  );
}

export function isCompanyShareOwnershipUltimateCompositeEntity(
  item: unknown,
): item is CompanyShareOwnershipUltimateCompositeEntity {
  return typeof item === 'object' && item !== null && item.hasOwnProperty('company_share_ownership_ultimate');
}

export function isCompanyShareOwnershipIndirectCompositeEntity(
  item: unknown,
): item is CompanyShareOwnershipIndirectCompositeEntity {
  return typeof item === 'object' && item !== null && item.hasOwnProperty('company_share_ownership_indirect');
}

export function isCompanyShareOwnershipBeneficialCompositeEntity(
  item: unknown,
): item is CompanyShareOwnershipBeneficialCompositeEntity {
  return (
    typeof item === 'object' &&
    item !== null &&
    item.hasOwnProperty('company_share_ownership_beneficial') &&
    item.hasOwnProperty('ownership_paths_composite')
  );
}

export function isCompanyShareOwnershipDirectCompositeEntity(
  item: unknown,
): item is CompanyShareOwnershipDirectCompositeEntity {
  return typeof item === 'object' && item !== null && item.hasOwnProperty('company_share_ownership_direct');
}
